import { inject, injectable } from "inversify";
import { TYPES } from "@utils/inversifyJS/types";
import type { IFastaRepository } from "@domain/repositories";

@injectable()
class DeleteFastaService {
  @inject(TYPES.IFastaRepository)
  private _fastaRepository!: IFastaRepository;

  async executeAsync(projectId: string, fileName: string, folder: string | undefined, rootPath?: string | null): Promise<boolean> {
    return this._fastaRepository.deleteFileAsync(projectId, fileName, folder, rootPath);
  }
}
export { DeleteFastaService };
